// core/base/master-view-model.ts
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MasterService } from './master-service';
import { HttpClient } from '@angular/common/http';

export abstract class MasterViewModel<T> {
    form!: FormGroup;  
    protected fb = new FormBuilder();
    protected validators = Validators;
    protected service: MasterService<T>;

    constructor(
        protected http: HttpClient,
        protected baseUrl: string,
        protected moduleName: string
    ) {
        this.service = new MasterService<T>(http, baseUrl);
    }

    canAccess(): boolean {
        const access = this.service.hasModuleAccess(this.moduleName);
        if (!access) alert(`Access Denied to ${this.moduleName}`);
        return access;
    }

    createForm(config: Record<string, any>): void {
        this.form = this.fb.group(config);
    }

    validateForm(): boolean {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return false;
        }
        return true;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.service.getAll().subscribe({
                next: (res: T[]) => {
                    resolve(res);
                },
                error: (err) => {                   
                    reject(err);
                }
            });
        });
    }
    save(): Promise<any> {
        if (!this.validateForm()) return Promise.reject('Form validation failed');
        const payload = this.form.getRawValue();
        return new Promise((resolve, reject) => {
            this.service.save(payload).subscribe({
                next: (res) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                }
            });
        });
    }
    delete(id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.service.delete(id).subscribe({
                next: (res) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                }
            });
        });
    }
}
